<template>
  <a-spin tip="Loading..." :spinning="isLoading" size="large">
    <div class="spin-content">
      <h3>Re-Order Cards</h3>
      <div class="row">
        <div class="col-6 d-flex flex-column justify-content-between">
          <div class="card-item-detail">
            <!-- <div v-if="!empty(data.pastors_name)">
            <span class="mr-2">Pastors Name: </span>
            <span>{{ data.pastors_name }}</span>
          </div>
          <div v-if="!empty(data.church_name)">
            <span class="mr-2">Church Name: </span>
            <span>{{ data.church_name }}</span>
          </div>
          <div v-if="!empty(data.church_email)">
            <span class="mr-2">Church Email: </span>
            <span>{{ data.church_email }}</span>
          </div>
          <div v-if="!empty(data.church_phone)">
            <span class="mr-2">Church Phone: </span>
            <span>{{ data.church_phone }}</span>
          </div>
          <div v-if="!empty(data.website)">
            <span class="mr-2">Website: </span>
            <a :href="data.website" target="_blank" rel="noopener noreferrer">{{ data.website }}</a>
          </div>
          <div v-if="!empty(data.website)">
            <span class="mr-2">Website: </span>
            <a :href="data.website" target="_blank" rel="noopener noreferrer">{{ data.website }}</a>
          </div>
          <div v-if="!empty(data.service_times)">
            <span class="mr-2">Service Times: </span>
            <span>{{ data.service_times }}</span>
          </div>
          <div v-if="!empty(data.proofs_email)">
            <span class="mr-2">Proofs Email: </span>
            <span>{{ data.proofs_email }}</span>
          </div>
          <div v-if="!empty(data.notes)">
            <span class="mr-2">Notes: </span>
            <span>{{ data.notes }}</span>
          </div>
          <div class="border-bottom border-info w-100 my-1" />
          <span class="mr-2" v-html="`Card Address: <br/>${getCardAddress}`"></span>
          <div class="border-bottom border-info w-100 my-1" /> -->
            <span class="mr-2" v-html="`Shipping Address: <br/>${getShippingAddress}`"></span>
          </div>

          <div class="row mt-2">
            <a-button size="large" type="primary" class="text-center p-2 mr-4" ghost @click="doReOrder">Approve & Re-order</a-button>
            <a-button size="large" type="primary" class="text-center p-2" ghost @click="doStartOver">Start over</a-button>
          </div>
        </div>
        <div class="col-6 d-flex flex-column justify-content-between">
          <div v-if="!empty(cardUrl.proofUrl)">
            <!-- <p>Proof Image</p> -->
            <img :src="cardUrl.proofUrl" alt="back" class="w-100 my-1 my-sm-0 mr-sm-1 cursor-pointer" @click="viewImage(cardUrl.proofUrl, 'Proof Image')" />
          </div>
          <template v-else>
            <div>
              <p>Card Front</p>
              <img :src="cardUrl.cardFrontUrl" alt="front" class="w-100 my-1 my-sm-0 mr-sm-1 cursor-pointer" @click="viewImage(cardUrl.cardFrontUrl, 'Card Front')" />
            </div>
            <div>
              <p>Card Back</p>
              <img :src="cardUrl.cardBackUrl" alt="back" class="w-100 cursor-pointer" @click="viewImage(cardUrl.cardBackUrl, 'Card Back')" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </a-spin>
</template>
<script>
import { empty } from '@/utils';
import AdminService from '@/services/AdminService';
import { keys, includes, get } from 'lodash';
import { mapGetters } from 'vuex';

export default {
  props: {
    cardUrl: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
  }),
  computed: {
    ...mapGetters(['user']),
    getCardAddress() {
      let address = '';
      if (!empty(this.data.card_address)) {
        address += `${this.data.card_address}<br/>`;
      }
      if (!empty(this.data.card_address2)) {
        address += `${this.data.card_address2}<br/>`;
      }
      if (!empty(this.data.card_city)) {
        address += `${this.data.card_city}<br/>`;
      }
      if (!empty(this.data.card_state)) {
        address += `${this.data.card_state}<br/>`;
      }
      if (!empty(this.data.card_zipcode)) {
        address += `${this.data.card_zipcode}`;
      }
      return address;
    },
    getShippingAddress() {
      let address = '';
      if (!empty(this.data.shipping_address)) {
        address += `${this.data.shipping_address}<br/>`;
      }
      if (!empty(this.data.shipping_address2)) {
        address += `${this.data.shipping_address2}<br/>`;
      }
      if (!empty(this.data.shipping_city)) {
        address += `${this.data.shipping_city}<br/>`;
      }
      if (!empty(this.data.shipping_state)) {
        address += `${this.data.shipping_state}<br/>`;
      }
      if (!empty(this.data.shipping_zipcode)) {
        address += `${this.data.shipping_zipcode}`;
      }
      return address;
    },
  },
  methods: {
    empty,
    doStartOver() {
      this.$emit('onStartOver');
    },
    async doReOrder() {
      try {
        if (!this.isLoading) {
          this.isLoading = true;
          const dataSubmit = { ...this.data };
          const excludeFields = ['updated_at', 'created_at', 'status'];
          keys(dataSubmit).forEach(item => {
            if (empty(dataSubmit[item]) || includes(excludeFields, item)) {
              delete dataSubmit[item];
            }
          });
          const resp = await AdminService.cardOrder(this.user.userId).reOrderCard(dataSubmit);
          console.log({ resp });
          this.$emit('onSuccess');

          this.$notification['success']({
            message: 'Successfully!',
            description: 'We will send you an additional order of these cards',
          });
        }
      } catch (error) {
        console.error({ error });
        const errorText = get(error, 'response.data.error', error.message);
        const h = this.$createElement;
        this.$error({
          title: '',
          centered: true,
          class: 'custom-result',
          // eslint-disable-next-line
          content: h('a-result', {
            props: {
              status: 'error',
              title: 'Error!',
              subTitle: errorText,
            },
          }),
        });
      } finally {
        this.isLoading = false;
      }
    },
    viewImage(url, title) {
      this.$emit('onOpenImage', { url, title });
    },
  },
};
</script>
<style lang="scss">
.card-item-detail {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
</style>
